import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/core/api/api.service';
import { ServiceGlobalValueService } from 'src/app/core/services/service-engine/service-global-value/service-global-value.service';
import { ServiceQuatationsService } from 'src/app/core/services/service-engine/service-quatations/service-quatations.service';

@Component({
  selector: 'app-service-quatation-info',
  templateUrl: './service-quatation-info.component.html',
  styleUrls: ['./service-quatation-info.component.scss'],
})
export class ServiceQuatationInfoComponent implements OnInit {
  selectedquatation = [];
  quatations: any = [];
  orderId: string;
  @Input() quotationData;
  @Input() orderStatus;
  @Output() updateQuotationData = new EventEmitter();
  providers: any;
  facilities = [];

  constructor(
    private serviceQuatations: ServiceQuatationsService,
    private activatedRoute: ActivatedRoute,
    private globalServiceStatus: ServiceGlobalValueService,
  ) {}

  ngOnInit(): void {
    this.orderId = this.activatedRoute.snapshot.paramMap.get('id');
    this.providers = this.quotationData.data;
    this.providers.forEach((provider) => {
      this.facilities.push(provider.facility);
    });
    this.getQuatations();
  }

  getQuatations(): void {
    this.serviceQuatations.getServiceQutationOptions(this.orderId).subscribe(
      (res) => {
        this.quatations = res;
        this.globalServiceStatus.changeProviders(this.quatations);
      },
      (error) => {
        console.log(error);
      },
    );
  }

  setquatation(event) {
    this.selectedquatation = event;
  }

  sendSelectedQuatations() {
    const sentData = {
      order_pk: this.orderId,
      facilities: this.selectedquatation,
    };
    this.serviceQuatations
      .sendSelectedServiceQuatationOptions(sentData)
      .subscribe(
        (res) => {
          this.quatations.forEach((elem) => {
            this.selectedquatation.forEach((selected) => {
              if (elem.id == selected) this.facilities.push(elem);
            });
          });
          this.updateQuotationData.emit(true);
          this.getQuatations();
          this.selectedquatation = [];
        },
        (error) => {
          console.log(error);
        },
      );
  }
}
